import { Fragment, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import FormProvince, { ProvinceForm } from 'system/geographic/components/province/form';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonProvinceCrumbs } from '../constants';
import { toast } from 'react-toastify';

const ProvinceNewPage = (): React.ReactElement => {
  const { post: insertProvince } = useHttpFetch(`${__MUNICIPALITY_API_URL__}/geo/provincia`);

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: ProvinceForm | undefined) => {
      insertProvince({
        codRegione: formValues?.region,
        regione: {
          key: {
            codice: formValues?.region,
          },
        },
        nome: formValues?.name,
        key: {
          codice: formValues?.code,
        },
      }).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/geografiche/italia/provincia');
      });
    },
    [insertProvince, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonProvinceCrumbs, { name: 'Nuova Provincia' }]} />
      <FormProvince
        title="Nuova Provincia"
        onOk={onSubmit}
        onCancel={() => {
          navigate('/sistema/geografiche/italia/provincia');
        }}
      />
    </Fragment>
  );
};

ProvinceNewPage.displayName = 'Province new page component';

export default ProvinceNewPage;
